import { render, staticRenderFns } from "./UploadPemFile.vue?vue&type=template&id=e6478a6a&"
import script from "./UploadPemFile.vue?vue&type=script&lang=js&"
export * from "./UploadPemFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadPemFile.vue?vue&type=style&index=0&id=e6478a6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports